import { ENav } from "../types";
import { TBreadcrumbItem } from "./types";
import { routePaths } from "routes/constants";

export const MAIN_PATH_MAP: Record<ENav, TBreadcrumbItem> = {
  [ENav.PERSONAL]: {
    label: "personal_account",
  },
  [ENav.CORPORATION]: {
    label: "corporation",
    link: routePaths.root.corp.root.root,
  },
  [ENav.BUSINESS_UNIT]: {
    label: "business_unit",
    link: routePaths.root.bu.root.root,
  },
  [ENav.COMMUNITY]: {
    label: "community",
  },
  [ENav.KENSAKU_KUN]: {
    label: "kensaku_kun",
  },
  [ENav.SEARCH]: {
    label: "search_accounts",
  },
};
